// extracted by css-extract-rspack-plugin
export default {"row":"A2wHH1RBmOoSSu9s","textarea":"cf98Wl6M4wkxVVtw"};